// eslint-disable-next-line no-unused-vars
function CosmeticPage (frameName, pageHref, parameters) {
    this.FrameName = frameName;
    this.PageHref = pageHref;
    this.Parameters = parameters;
}

CosmeticPage.prototype = {
    clone: function () {
        return new CosmeticPage(
            this.FrameName,
            this.PageHref,
            this.Parameters
        );
    }
};
